// routes/guards/rootLoader.js
import { redirect } from "react-router-dom";
import { getAuthStatus, landingPathFor } from "../../auth/navigate";
import { USER_STATUS } from "../../auth/constants";

// Routes that should NEVER be redirected by the guest flow
const PUBLIC_ALWAYS = [
  "/login",
  "/register",
  "/verify-email",
  "/reset-password",
  "/age",
  "/underage",
  "/language",
  "/terms",
  "/about-us",
  "/universe",
];

const isPublicPath = (path) =>
  PUBLIC_ALWAYS.includes(path) ||
  path.startsWith("/terms/") ||
  path.startsWith("/about-us/") ||
  path.startsWith("/universe/");

const isHomepage = (path) => path === "/" || path === "/home";

export function rootLoader({ request }) {
  const url = new URL(request.url);
  const path = url.pathname.replace(/\/+$/, "") || "/";

  const status = getAuthStatus();

  // ✅ If logged in:
  if (status !== USER_STATUS.UNAUTH) {
    // Send authenticated users away from entry/public pages to their landing
    if (
      isHomepage(path) ||
      path === "/login" ||
      path === "/register" ||
      path === "/verify-email"
    ) {
      return redirect(landingPathFor(status));
    }
    // Otherwise, let protected loaders (roleGuard) handle auth/role checks
    return null;
  }

  // ✅ If guest (UNAUTH): never block public pages
  if (isPublicPath(path)) {
    return null;
  }

  // ✅ Homepage is freely accessible for guests.
  // If language was never chosen, keep default language as English.
  if (isHomepage(path)) {
    if (!localStorage.getItem("cm_lang")) {
      localStorage.setItem("cm_lang", "en");
    }
    return null;
  }

  // For other non-public pages under the root layout (if any exist),
  // do nothing here—either the page is public content or has its own loader.
  return null;
}
